export const routeEntryPoint = '/';
export const baseUrl = (uri) =>  {
	return uri ? '/' + uri : '/';
};



// WEBPACK FOOTER //
// ./frontend/cabinets/config/route-entry-point.js